(ns splash.ui.lender-portal.feature-flags
  "A ns to keep all feature flags in one place.
   With the purpose of avoiding code digging to identify all existing flags in the project")

(def notes-table "notes_tabe")
